import { tx as translateInterfaceText } from '@/utils/i18n';

import { VideoLogo } from '@/store/videoFeatures';

export const LOGO_POSITIONS = [
  { value: 'top-left' as const, get label() { return translateInterfaceText("Superior Esquerda"); } },
  { value: 'top-center' as const, get label() { return translateInterfaceText("Superior Centro"); } },
  { value: 'top-right' as const, get label() { return translateInterfaceText("Superior Direita"); } },
  { value: 'center-left' as const, get label() { return translateInterfaceText("Centro Esquerda"); } },
  { value: 'center' as const, get label() { return translateInterfaceText("Centro"); } },
  { value: 'center-right' as const, get label() { return translateInterfaceText("Centro Direita"); } },
  { value: 'bottom-left' as const, get label() { return translateInterfaceText("Inferior Esquerda"); } },
  { value: 'bottom-center' as const, get label() { return translateInterfaceText("Inferior Centro"); } },
  { value: 'bottom-right' as const, get label() { return translateInterfaceText("Inferior Direita"); } },
];

export function buildLogoUrl(logo: VideoLogo): string {
  if (!logo.linkUrl) return '';
  
  try {
    const url = new URL(logo.linkUrl);
    
    // Add UTM parameters if enabled
    if (logo.utmEnabled) {
      if (logo.utmSource) url.searchParams.set('utm_source', logo.utmSource);
      if (logo.utmMedium) url.searchParams.set('utm_medium', logo.utmMedium);
      if (logo.utmCampaign) url.searchParams.set('utm_campaign', logo.utmCampaign);
    }
    
    return url.toString();
  } catch (error) {
    console.error('Invalid logo URL:', error);
    return logo.linkUrl;
  }
}

export function validateUrl(url: string): { valid: boolean; message?: string } {
  if (!url || url.trim() === '') {
    return { valid: false, message: translateInterfaceText("A URL não pode estar vazia") };
  }
  
  // Check if starts with http:// or https://
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return { valid: false, message: translateInterfaceText("A URL deve começar com http:// ou https://") };
  }
  
  try {
    new URL(url);
    return { valid: true };
  } catch {
    return { valid: false, message: translateInterfaceText("URL inválida") };
  }
}

export const DEFAULT_LOGO_CUSTOMIZATION = {
  border: {
    enabled: false,
    color: 'rgba(0, 0, 0, 0.1)',
    width: 1,
  },
  shadow: {
    enabled: false,
    color: 'rgba(0, 0, 0, 0.2)',
    blur: 8,
    intensity: 50,
  },
  hoverEffect: 'none' as 'none' | 'darken' | 'lighten' | 'scale',
};
